<template>
  <div :class="componentClassName">
    <div id="userStatus" class="m-current-user-status__body" @click="handleClick">
      <div class="m-current-user-status__label">{{ businessHourText }}</div>
      <div class="m-current-user-status__avatar">
        <a-avatar :active="online" />
        <div :class="indicatorClassName">
          <a-icon :icon="statusIcon" color="white" />
        </div>
      </div>
      <div class="m-current-user-status__user-info">
        <div id="currentUserStatus-user-name" class="m-current-user-status__user-name">
          {{ currentUserName }}
        </div>
        <div class="m-current-user-status__status">
          {{ statusText }}
        </div>
      </div>
      <div class="m-current-user-status__caret">
        <a-icon :icon="iconShape" :color="iconColor" />
      </div>
    </div>
    <div class="m-current-user-status__option-container">
      <ul class="m-current-user-status__options">
        <li>
          <a-button id="changeStatus" type="text" @click="changeStatus">
            <div :class="switchIndicatorClassName">
              <a-icon :icon="switchStatusIcon" color="white" />
            </div>
            <strong>{{ switchStatusText }}</strong> に変更
          </a-button>
        </li>
        <li>
          <a-button id="editProfile" type="text" @click="editProfile()">プロフィールの編集</a-button>
        </li>
        <li>
          <a-button id="logout" type="text" @click="logout">ログアウト</a-button>
        </li>
        <li class="m-current-user-status__account-id">契約ID：　{{ companyId }}</li>
        <li v-if="isTrial" class="m-current-user-status__phone-number">050番号：{{ trialPhonenumber }}</li>
        <li v-if="!isTrial" class="m-current-user-status__phone-number">
          <span class="m-current-user-status__phone-number__label"
            >050番号：{{ !telNumberList.length ? '　ー' : '' }}</span
          >
          <a-select-field v-if="telNumberList.length" :placeholder="phonenumberLabel" :options="telNumberList" />
        </li>
      </ul>
    </div>
    <teleport to="body">
      <o-modal
        id="currentUserStatus_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AAvatar from '@/components/atoms/avatar';
import AButton from '@/components/atoms/button';
import AIcon from '@/components/atoms/icon';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { utils } from '@/common/utils.js';
import { BUSINESS_HOUR_STATUS } from '@/libs/constants.js';

export default {
  name: 'm-current-user-status',
  components: {
    AAvatar,
    AButton,
    AIcon,
  },
  mixins: [customRequest],
  props: {
    online: {
      type: Boolean,
      default: false,
    },
    businessHour: {
      type: Boolean,
      default: true,
    },
    class: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      required: true,
    },
    companyId: {
      type: String,
      required: true,
    },
    editProfileUrl: {
      type: String,
      default: '#',
    },
    logoutUrl: {
      type: String,
      default: '#',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    handleOnlineStatusChange: {
      type: Function,
      default: () => {},
    },
    handleLogout: {
      type: Function,
      default: () => {},
    },
  },
  emits: [],
  data() {
    return {
      opened: false,
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      telNumberList: [],
      trialPhonenumber: messageContent.statusPhoneNumberTrial(),
      intervalId: null,
      prevMinute: 0,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers(
        'm-current-user-status',
        this.online ? 'online' : '',
        this.businessHour === BUSINESS_HOUR_STATUS.BUSINESS_HOUR ? 'during-business-hour' : 'out-of-business-hour',
        this.opened ? 'opened' : ''
      );
      return `${baseClassName} ${this.class}`.trim();
    },
    indicatorClassName() {
      return mapModifiers('m-current-user-status__indicator', this.online ? 'active' : 'inactive');
    },
    switchIndicatorClassName() {
      return mapModifiers('m-current-user-status__indicator', this.online ? 'inactive' : 'active');
    },
    statusIcon() {
      return this.online ? 'check' : 'minus';
    },
    switchStatusIcon() {
      return this.online ? 'minus' : 'check';
    },
    statusText() {
      return this.online ? '応答可能' : '応答不可';
    },
    switchStatusText() {
      return this.online ? '応答不可' : '応答可能';
    },
    businessHourText() {
      if (this.businessHour === BUSINESS_HOUR_STATUS.BUSINESS_HOUR) return '営業時間中';
      if (this.businessHour === BUSINESS_HOUR_STATUS.BREAK_TIME_HOUR) return '休憩時間中';
      return '営業時間外';
    },
    iconShape() {
      return this.opened ? 'caret-up' : 'caret-down';
    },
    iconColor() {
      if (this.businessHour === BUSINESS_HOUR_STATUS.BUSINESS_HOUR) return 'white';
      return 'black';
    },
    currentUserName() {
      return this.userName.replace('_', ' ');
    },
    isTrial() {
      return utils.chkTrialCompanyID(this.companyId);
    },
    phonenumberLabel() {
      return this.telNumberList.length === 1 ? this.telNumberList[0].label : `${this.telNumberList.length}番号`;
    },
    serviceTermination() {
      return this.$store.state.user.serviceTermination;
    },
  },
  watch: {
    businessHour(val, oldVal) {
      this.businessHourStatus = val;
    },
    opened(val) {
      if (!val || this.isTrial) return;
      if (!this.serviceTermination) {
        this.fetchNumberList();
      }
    },
  },
  mounted() {
    // 営業時間チェックをかける
    if (!this.serviceTermination) {
      this.intervalId = setInterval(this.updBusinessHours, 1000);
    }
  },
  unmounted() {
    // 解除
    if (!this.serviceTermination) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    async updBusinessHours() {
      const now = new Date();
      const currMinute = now.getMinutes();

      // 分の値が変わったら営業時間を取得
      if (currMinute !== this.prevMinute) {
        this.prevMinute = currMinute;

        // 最新の営業時間状態を取得する
        await this.postRequest('/checkBusinessHours')
          .then(data => {
            if (data.status === 'success') {
              this.$store.state.businessHour = data.businessHourStatus; // 営業時間状態を更新
            } else {
              this.showErrorModal(messageContent.requireTry('営業時間チェック'));
            }
          })
          .catch(error => {
            this.showErrorModal(messageContent.requireTry('営業時間チェック'));
          });
      }
    },
    handleClick() {
      this.opened = !this.opened;
    },
    editProfile: function () {
      this.$router.push('/profilelist');
      this.opened = !this.opened;
    },
    changeStatus() {
      const onlineStatus = !this.online;
      this.opened = !this.opened;
      this.handleOnlineStatusChange(onlineStatus);
    },
    logout: function () {
      const self = this;
      this.postRequest('/login/logout').then(data => {
        if (data.status === 'success') {
          self.handleLogout();
          //this.$router.push('/login');
          window.location.href = '/login';
        } else if (data.status === 'failed') {
          self.showErrorModal(messageContent.requireTry('ログアウト'));
        }
      });
    },
    fetchNumberList() {
      this.telNumberList = [];
      this.postRequest('/servicecondition/getallocatedtelnumberlist')
        .then(res => {
          if (res.status === 'failed') throw new Error(res.status);
          for (const item of res.data) {
            this.telNumberList.push({
              value: item.telNumber,
              label: `${item.numberName || '-'}（${item.telNumber}）`,
              disabled: true,
            });
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('電話番号一覧の取得'));
        });
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
  },
};
</script>
